











import { Component, Vue } from 'vue-property-decorator';
import Popup from '@/components/popups/Popup.vue';
import PopupCloseButton from '@/components/popups/PopupCloseButton.vue';
import { namespace } from 'vuex-class';
import { playSound } from '@/utils/playSound';

const puzzle = namespace('Puzzle');

const ui = namespace('UI');

declare const sdkHandler: any;

@Component({
  components: {
    Popup,
    PopupCloseButton
  },
})
export default class HintPopup extends Vue {
  @ui.Mutation
  private closePopup!: () => void;

  @puzzle.Action
  private showHint!: () => void;

  private showHintAd() {
    playSound('buttonClickSound');
    window.setTimeout(() => {
      (window as any).sdkHandler.trigger('rewardedAd', {
        callback: (result: Boolean) => {
          if (result) {
            this.closePopup();
            this.showHint();
          }
        }
      }, this)
    }, 200)

  }

  private getAHint: string = (window as any).languages['GetAHint'];
}
